module.exports = __webpack_public_path__ + "img/logo-magisteriodepichincha.94acf749.png";